import {IModel} from "maps-angular-components";
import {Carteira, CarteiraDTO} from "../carteira/carteira.model";

export interface GrupoCarteiraDTO {
  id: string;
  nome: string;
  descricao?: string;
  carteiras: CarteiraDTO[];
}

export class GrupoCarteira implements IModel {

  id: string;
  nome: string;
  descricao?: string;
  carteiras: Carteira[] = [];

  constructor(obj?: GrupoCarteiraDTO) {
    if (obj) {
      this.id = obj.id;
      this.nome = obj.nome;
      this.descricao = obj.descricao;
      this.carteiras = obj.carteiras.map(carteira => new Carteira(carteira));
    }
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.nome;
  }

  equals(obj: IModel) {
    return obj.getId() == obj.getId()
  }

  toJSON() {
    return Object.assign(this);
  }
}
